<woa-modal-page-layout [title]="'woa.heading.orders.title'"
                       [subtitle]="saleCount() === 0 ? 'woa.label.orders.orderCount.zero' : saleCount() === 1 ? 'woa.label.orders.orderCount.singular' : 'woa.label.orders.orderCount.plural'"
                       [translationParams]="{'count': saleCount()}">
    @if (saleCount() < 1) {
        <woa-content-message [level]="MessageLevel.INFO"
                             [text]="'woa.message.orders.noOrders'"></woa-content-message>
    }
    @if (recentOrders().length) {
        <woa-field-group [title]="identityModel.isGuestUser() ? 'woa.heading.orders.recentOrders' : 'woa.heading.orders.currentOrders'">
            @for (recentOrder of recentOrders(); track recentOrder) {
                <div class="order">
                    <div class="order-title">
                        <div class="order-title-type">
                            {{ getOrderDescription(recentOrder) | translate }}
                        </div>
                        @if (recentOrder.placedOrder?.receiptId) {
                            <div class="order-title-number">
                                {{ recentOrder.placedOrder?.receiptId }}
                            </div>
                        }
                    </div>
                    @if (recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_AT_TABLE) {
                        <div class="order-details"
                             [innerHTML]="'woa.message.order.summary.tableNumber' | translate: {
                                 'table': recentOrder.orderInitiation.tableNumber
                             }"></div>
                    }
                    <div class="order-details"
                         [innerHTML]="getOrderMessage(recentOrder, recentOrder.initiatedOrder.store) | translate:{
                     'date': recentOrder.placedOrder.placedDateTime | date:'medium',
                     'time': getOrderTime(recentOrder),
                     'groupOrderName': recentOrder.orderInitiation.transferTargetName | possessive,
                     'store': recentOrder.initiatedOrder.store.collectiveStoreName,
                     'address': recentOrder.orderPlacement.address.formattedAddress
                 } | html"></div>
                    <div class="order-details"
                         [innerHTML]="'woa.message.order.summary.orderTotal' | translate:{
                             'total': recentOrder.initiatedOrder.orderTotal | woaCurrency
                         }"></div>
                    <div class="order-actions">
                        <woa-link [link]="'woa.button.order.viewOrder'"
                                  (onActivate)="viewOrderDetails(recentOrder)"></woa-link>
                    </div>
                </div>
            }
        </woa-field-group>
    }
    @if (memberSalesSearchModel.dataSignal()?.length) {
        <woa-field-group [title]="'woa.heading.orders.orderHistory'">
            @for (sale of memberSalesSearchModel.data; track sale) {
                <div class="order">
                    <div class="order-title">
                        {{ getSaleDescription(sale) | translate }}
                    </div>
                    @if (sale.saleReceiptNo) {
                        <div class="order-title subtitle">
                            {{ "woa.label.sale-summary.saleReceiptNo" | translate }} {{ sale.saleReceiptNo }}
                        </div>
                    }
                    <div class="order-details"
                         [innerHTML]="'woa.message.order.summary.orderPlaced' | translate:{
                             'date': sale.saleDate | date:'medium',
                             'store': sale.outletName
                         }"></div>
                    <div class="order-details"
                         [innerHTML]="'woa.message.order.summary.orderTotal' | translate:{
                             'total': sale.saleTotal | woaCurrency
                         }"></div>
                    @if (sale.pointsAccrued) {
                        <div class="order-details"
                             [innerHTML]="'woa.message.order.summary.pointsEarned' | translate:{
                             'points': sale.pointsAccrued
                         }"></div>
                    }
                    <div class="order-actions">
                        <woa-link [link]="'woa.button.sale-summary.viewReceipt'"
                                  (onActivate)="viewReceipt(sale)"></woa-link>
                        @if (sale.customerRefNo && configurationModel.app()?.orderReceivedEmail.id) {
                            <woa-link [link]="'woa.button.sale-summary.sendInvoice'"
                                      (onActivate)="requestInvoice(sale)"></woa-link>
                        }
                    </div>
                </div>
            }
        </woa-field-group>
    }
</woa-modal-page-layout>
